/**
 * Aura Cart — gaveta.
 *
 * O app NAO substitui a gaveta do tema. Ele acrescenta a ela os modulos que a
 * loja de referencia tem, e reveste o que ja existe. Quantidade, remover e
 * re-render continuam sendo do tema.
 *
 * O tema troca o conteudo inteiro da gaveta a cada mudanca de carrinho, entao
 * tudo que este arquivo injeta e reinjetado depois de cada troca. A marcacao
 * carrega um marcador para nunca duplicar.
 *
 * Falha aberto: qualquer erro deixa a gaveta original de pe.
 */
(function () {
  'use strict';

  var cfg = null;
  var cacheProduto = {};
  var trabalhando = false;
  var ultimoCarrinho = null;
  var ultimaAssinatura = '';

  /* ---------------------------------------------------------------- basico */

  function lerConfig() {
    var no = document.querySelector('[data-aura-cart-config]');
    if (!no) return null;
    try {
      return JSON.parse(no.textContent);
    } catch (e) {
      return null;
    }
  }

  function dinheiro(centavos) {
    var formato = (cfg && cfg.moneyFormat) || '${{amount}}';
    var valor = (centavos / 100).toFixed(2);
    var partes = valor.split('.');
    var inteiro = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var comCentavos = inteiro + '.' + partes[1];
    var semCentavos = inteiro;

    return formato
      .replace(/\{\{\s*amount\s*\}\}/g, comCentavos)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, semCentavos)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, comCentavos.replace(/,/g, '.').replace(/\.(\d{2})$/, ',$1'))
      .replace(/<[^>]*>/g, '');
  }

  function enxuto(texto) {
    return String(texto).replace(/(\d)\.00(?!\d)/g, '$1');
  }

  function el(tag, classe, texto) {
    var n = document.createElement(tag);
    if (classe) n.className = classe;
    if (texto != null) n.textContent = texto;
    return n;
  }

  function gaveta() {
    return document.querySelector('cart-drawer');
  }

  /**
   * O tema tem DOIS jeitos de atualizar a gaveta, e eles nao sao iguais:
   *
   *  - adicionar ao carrinho troca o `.drawer__inner` inteiro (elemento novo);
   *  - mudar quantidade ou remover troca so o CONTEUDO de dentro dele, e o
   *    elemento continua o mesmo.
   *
   * Por isso nao da pra marcar o elemento e confiar no marcador: no segundo
   * caso ele sobrevive e os modulos nao. Quem decide e a presenca dos modulos
   * na tela.
   */
  function faltaMontar(d) {
    if (!d.querySelector('.drawer__inner')) return false;
    // marca de vazio presa numa gaveta que tem item: o cabecalho inteiro fica
    // escondido, inclusive o botao de fechar
    if (d.classList.contains('is-empty') && d.querySelector('.cart-item')) return true;
    if (!d.querySelector('.aura-cart__count')) return true;
    if (cfg.textos.aviso && !d.querySelector('.aura-cart__banner')) return true;
    if (cfg.mostrarBandeiras && cfg.bandeiras && cfg.bandeiras.length && !d.querySelector('.aura-cart__pay')) return true;
    return false;
  }

  function pedirJson(url, opcoes) {
    return fetch(url, opcoes).then(function (r) {
      return r.json();
    });
  }

  /* -------------------------------------------------------------- cabecalho */

  var ICONE_CARRINHO =
    '<svg class="aura-cart__icon" aria-hidden="true" focusable="false" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path fill="currentColor" fill-rule="evenodd" d="M20.5 6.5a4.75 4.75 0 00-4.75 4.75v.56h-3.16l-.77 11.6a5 5 0 004.99 5.34h7.38a5 5 0 004.99-5.33l-.77-11.6h-3.16v-.57A4.75 4.75 0 0020.5 6.5zm3.75 5.31v-.56a3.75 3.75 0 10-7.5 0v.56h7.5zm-7.5 1h7.5v.56a3.75 3.75 0 11-7.5 0v-.56zm-1 0v.56a4.75 4.75 0 109.5 0v-.56h2.22l.71 10.67a4 4 0 01-3.99 4.27h-7.38a4 4 0 01-4-4.27l.72-10.67h2.22z"></path></svg>';

  var ICONE_CADEADO =
    '<svg class="aura-cart__lock" aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="currentColor">' +
    '<path d="M17 9V7a5 5 0 10-10 0v2H6a2 2 0 00-2 2v9a2 2 0 002 2h12a2 2 0 002-2v-9a2 2 0 00-2-2h-1zM9 7a3 3 0 116 0v2H9V7z"></path></svg>';

  function montarCabecalho(raiz, quantidade) {
    var h = raiz.querySelector('.drawer__heading');
    if (!h) return;

    h.innerHTML =
      ICONE_CARRINHO +
      '<span class="aura-cart__title"></span>' +
      '<span class="aura-cart__count" aria-hidden="true"></span>';
    h.querySelector('.aura-cart__title').textContent = ' ' + cfg.textos.titulo + ' ';
    h.querySelector('.aura-cart__count').textContent = '(' + quantidade + ')';
  }

  function montarFaixa(raiz) {
    if (!cfg.textos.aviso) return;
    var cabecalho = raiz.querySelector('.drawer__header');
    if (!cabecalho || !cabecalho.parentNode) return;
    if (raiz.querySelector('.aura-cart__banner')) return;

    var faixa = el('div', 'aura-cart__banner', cfg.textos.aviso);
    cabecalho.parentNode.insertBefore(faixa, cabecalho.nextSibling);
  }

  /* ---------------------------------------------------------------- ofertas */

  function varianteDe(addon, escolha) {
    for (var i = 0; i < addon.variantes.length; i++) {
      var v = addon.variantes[i];
      var igual = true;
      for (var o = 0; o < escolha.length; o++) {
        if (v.opcoes[o] !== escolha[o]) {
          igual = false;
          break;
        }
      }
      if (igual) return v;
    }
    return null;
  }

  function noCarrinho(carrinho, produtoId) {
    for (var i = 0; i < (carrinho.items || []).length; i++) {
      if (carrinho.items[i].product_id === produtoId) return carrinho.items[i];
    }
    return null;
  }

  function montarAddon(addon) {
    var caixa = el('div', 'aura-cart__addon');
    caixa.setAttribute('data-aura-addon', String(addon.id));

    var foto = el('div', 'aura-cart__addon-img');
    var img = document.createElement('img');
    img.src = addon.imagem;
    img.alt = addon.titulo;
    img.loading = 'lazy';
    foto.appendChild(img);
    caixa.appendChild(foto);

    var corpo = el('div', 'aura-cart__addon-body');
    corpo.appendChild(el('div', 'aura-cart__addon-title', addon.titulo));
    if (addon.linha) corpo.appendChild(el('p', 'aura-cart__addon-line', addon.linha));

    var escolha = (addon.variantes[0] || {}).opcoes ? addon.variantes[0].opcoes.slice() : [];

    var grade = el('div', 'aura-cart__addon-options');
    addon.opcoes.forEach(function (opt, indice) {
      var campo = document.createElement('fieldset');
      campo.className = 'aura-cart__addon-option';
      campo.appendChild(el('legend', 'aura-cart__addon-optlabel', opt.nome));

      var select = document.createElement('select');
      select.className = 'aura-cart__addon-select';
      select.setAttribute('aria-label', opt.nome);
      opt.valores.forEach(function (valor) {
        var o = document.createElement('option');
        o.value = valor;
        o.textContent = valor;
        if (valor === escolha[indice]) o.selected = true;
        select.appendChild(o);
      });
      select.addEventListener('change', function () {
        escolha[indice] = this.value;
        atualizarPreco();
      });
      campo.appendChild(select);
      grade.appendChild(campo);
    });
    corpo.appendChild(grade);

    var precos = el('div', 'aura-cart__addon-price');
    var linhaPreco = el('div', 'aura-cart__addon-money');
    var was = el('del', 'aura-cart__addon-was');
    var now = el('span', 'aura-cart__addon-now');
    linhaPreco.appendChild(was);
    linhaPreco.appendChild(now);
    precos.appendChild(linhaPreco);

    var botoes = el('div', 'aura-cart__addon-buttons');
    var adicionar = el('button', 'aura-cart__addon-add', cfg.textos.adicionar);
    adicionar.type = 'button';
    botoes.appendChild(adicionar);
    precos.appendChild(botoes);
    corpo.appendChild(precos);
    caixa.appendChild(corpo);

    function atualizarPreco() {
      var v = varianteDe(addon, escolha) || addon.variantes[0];
      if (!v) return;
      now.textContent = dinheiro(v.preco);
      if (v.tabela > v.preco) {
        was.textContent = dinheiro(v.tabela);
        was.style.display = '';
      } else {
        was.textContent = '';
        was.style.display = 'none';
      }
      if (v.imagem) img.src = v.imagem;
      adicionar.disabled = !v.disponivel;
    }

    adicionar.addEventListener('click', function () {
      var v = varianteDe(addon, escolha) || addon.variantes[0];
      if (!v) return;
      adicionar.disabled = true;
      pedirJson(cfg.rotas.add, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
      })
        .then(redesenharGaveta)
        .catch(function () {
          adicionar.disabled = false;
        });
    });

    atualizarPreco();
    return caixa;
  }

  function montarOfertas(raiz, carrinho) {
    if (!cfg.addons || !cfg.addons.length) return;

    var itens = raiz.querySelector('cart-drawer-items');
    if (!itens) return;

    // refeito do zero a cada passada: o estado de cada oferta (adicionar ou
    // remover) depende do que esta no carrinho AGORA
    var antigo = raiz.querySelector('.aura-cart__addons');
    if (antigo) antigo.remove();
    itens.classList.remove('aura-cart--com-addons');

    // com carrinho vazio a referencia nao mostra o bloco
    if (!carrinho.item_count) return;

    var bloco = el('div', 'aura-cart__addons');
    if (cfg.textos.addonTitulo) bloco.appendChild(el('div', 'aura-cart__addons-title', cfg.textos.addonTitulo));
    if (cfg.textos.addonSubtitulo) bloco.appendChild(el('div', 'aura-cart__addons-sub', cfg.textos.addonSubtitulo));

    // Comportamento medido na referencia: a oferta que ja esta no carrinho SAI
    // da lista. Com as duas no carrinho, o bloco inteiro deixa de existir — e
    // volta sozinho quando o cliente remove alguma.
    var mostrou = 0;
    cfg.addons.forEach(function (addon) {
      if (!addon || !addon.variantes || !addon.variantes.length) return;
      if (noCarrinho(carrinho, addon.id)) return;
      bloco.appendChild(montarAddon(addon));
      mostrou++;
    });

    if (!mostrou) return;
    itens.appendChild(bloco);
    itens.classList.add('aura-cart--com-addons');
  }

  // Dois detalhes que o tema traz e a referencia nao tem: o cabecalho de colunas
  // "PRODUCT / TOTAL" e a lixeira no lugar da palavra Remove.
  // A referencia mostra o preco da linha e o subtotal SEM os centavos zerados
  // ($102, nao $102.00) e sem o codigo da moeda. Os precos do bloco de ofertas
  // mantem os centavos, que e como a referencia tambem os mostra.
  function enxugarValores(no) {
    if (!no) return;
    var caminhante = document.createTreeWalker(no, NodeFilter.SHOW_TEXT, null);
    var alvos = [];
    while (caminhante.nextNode()) alvos.push(caminhante.currentNode);
    for (var i = 0; i < alvos.length; i++) {
      var t = alvos[i].nodeValue;
      if (t.indexOf('.00') === -1 && t.indexOf(' USD') === -1) continue;
      var novo = t.replace(/(\d)\.00(?!\d)/g, '$1').replace(/\s?[A-Z]{3}\b/g, '');
      if (novo !== t) alvos[i].nodeValue = novo;
    }
  }

  function ajustarItens(raiz) {
    var cabecalho = raiz.querySelector('.cart-items thead, .cart-items caption');
    if (cabecalho) cabecalho.classList.add('aura-cart__hidden');

    var botoes = raiz.querySelectorAll('cart-remove-button .button');
    for (var i = 0; i < botoes.length; i++) {
      var b = botoes[i];
      if (b.getAttribute('data-aura-remove') === '1') continue;
      b.setAttribute('data-aura-remove', '1');
      b.textContent = (cfg.textos && cfg.textos.remover_item) || 'Remove';
    }

    // Rotulo do desconto na linha. O texto que o tema mostra e o NOME do desconto
    // que esta valendo; quando o app de bundle nao preenche esse campo, ele cai
    // no titulo da barra ("$23 Each"). Este campo normaliza o que aparece na
    // gaveta. Atencao: o checkout continua mostrando o nome real do desconto —
    // igualar os dois depende de como o desconto foi criado, nao daqui.
    var rotulo = cfg.textos && cfg.textos.rotuloDesconto;
    if (rotulo) {
      var chips = raiz.querySelectorAll('.discounts__discount');
      for (var c = 0; c < chips.length; c++) {
        var chip = chips[c];
        if (chip.getAttribute('data-aura-rotulo') === '1') continue;
        chip.setAttribute('data-aura-rotulo', '1');
        var texto = null;
        var caminhante = document.createTreeWalker(chip, NodeFilter.SHOW_TEXT, null);
        while (caminhante.nextNode()) {
          if (caminhante.currentNode.nodeValue.trim()) { texto = caminhante.currentNode; break; }
        }
        if (texto) texto.nodeValue = rotulo;
      }
    }

    enxugarValores(raiz.querySelector('.drawer__cart-items-wrapper') || raiz.querySelector('#CartDrawer-CartItems'));
  }

  /* ----------------------------------------------------------------- rodape */

  // A economia da referencia e contra o preco de TABELA, e /cart.js nao traz
  // esse campo. Uma chamada por produto do carrinho resolve, e o resultado fica
  // guardado pra nao repetir a cada re-render.
  function precosDeTabela(carrinho) {
    var handles = [];
    (carrinho.items || []).forEach(function (i) {
      if (i.handle && handles.indexOf(i.handle) === -1) handles.push(i.handle);
    });

    return Promise.all(
      handles.map(function (h) {
        if (cacheProduto[h]) return Promise.resolve(cacheProduto[h]);
        return pedirJson(cfg.rotas.raiz + 'products/' + h + '.js')
          .then(function (p) {
            var mapa = {};
            (p.variants || []).forEach(function (v) {
              mapa[String(v.id)] = v.compare_at_price || 0;
            });
            cacheProduto[h] = mapa;
            return mapa;
          })
          .catch(function () {
            cacheProduto[h] = {};
            return {};
          });
      })
    ).then(function () {
      var total = 0;
      (carrinho.items || []).forEach(function (i) {
        var mapa = cacheProduto[i.handle] || {};
        var tabela = mapa[String(i.variant_id)] || 0;
        var base = tabela > i.price ? tabela : i.price;
        total += base * i.quantity;
      });
      return total;
    });
  }

  function montarRodape(raiz, carrinho) {
    var rodape = raiz.querySelector('.drawer__footer');
    if (!rodape) return;

    if (cfg.esconderObservacao) {
      var nota = rodape.querySelector('details');
      if (nota) nota.classList.add('aura-cart__hidden');
    }

    var rotulo = rodape.querySelector('.totals__total, .totals__subtotal');
    if (rotulo && cfg.textos.subtotal) rotulo.textContent = cfg.textos.subtotal + ' ';

    // o tema escreve o total com o codigo da moeda ("$138.00 USD"); a
    // referencia mostra so o valor
    var valorTotal = rodape.querySelector('.totals__total-value, .totals__subtotal-value');
    if (valorTotal) valorTotal.textContent = enxuto(dinheiro(carrinho.total_price));

    // economia: criada uma vez e atualizada nas passadas seguintes
    var linha = rodape.querySelector('.aura-cart__savings');
    if (!linha) {
      var totais = rodape.querySelector('.totals');
      if (totais && totais.parentNode) {
        linha = el('p', 'aura-cart__savings');
        linha.style.visibility = 'hidden';
        totais.parentNode.insertBefore(linha, totais.nextSibling);
      }
    }
    if (linha) {
      precosDeTabela(carrinho).then(function (cheio) {
        var economia = cheio - carrinho.total_price;
        if (economia > 0) {
          linha.textContent = cfg.textos.economia + ' ' + enxuto(dinheiro(economia));
          linha.style.visibility = '';
        } else {
          linha.textContent = '';
          linha.style.visibility = 'hidden';
        }
      });
    }

    // botao de checkout com cadeado
    var botao = rodape.querySelector('.cart__checkout-button');
    if (botao && !botao.querySelector('.aura-cart__lock')) {
      botao.innerHTML = ICONE_CADEADO + '<span>' + cfg.textos.checkout + '</span>';
    }

    // bandeiras de pagamento, logo abaixo do botao
    var fila = rodape.querySelector('.aura-cart__pay');
    if (cfg.mostrarBandeiras && cfg.bandeiras && cfg.bandeiras.length && !fila) {
      var ctas = rodape.querySelector('.cart__ctas');
      if (ctas && ctas.parentNode) {
        fila = el('div', 'aura-cart__pay');
        fila.innerHTML = cfg.bandeiras.join('');
        ctas.parentNode.insertBefore(fila, ctas.nextSibling);
      }
    }

    // linha de garantia: na referencia ela vem DEPOIS das bandeiras, nao antes
    if (cfg.textos.garantia) {
      var aviso = rodape.querySelector('.tax-note');
      if (aviso) {
        aviso.textContent = cfg.textos.garantia;
        if (fila && fila.parentNode && aviso.parentNode) {
          fila.parentNode.insertBefore(aviso, fila.nextSibling);
        }
      }
    }
  }

  /* ------------------------------------------------------------- orquestra */

  function redesenharGaveta() {
    var d = gaveta();
    if (!d) return;
    var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    return fetch(raiz + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) {
        return r.json();
      })
      .then(function (dados) {
        if (typeof d.renderContents === 'function') {
          d.renderContents({ sections: dados });
          return;
        }
        var doc = new DOMParser().parseFromString(dados['cart-drawer'] || '', 'text/html');
        var novo = doc.querySelector('#CartDrawer');
        var atual = document.querySelector('#CartDrawer');
        if (novo && atual) atual.innerHTML = novo.innerHTML;
      })
      .catch(function () {});
  }

  function assinaturaDe(c) {
    return [c.item_count, c.total_price]
      .concat(
        (c.items || []).map(function (i) {
          return i.key + 'x' + i.quantity;
        })
      )
      .join('|');
  }

  /**
   * O tema marca a gaveta como vazia enquanto o carrinho esta vazio, e o CSS da
   * familia Dawn esconde o `.drawer__header` inteiro enquanto a marca existe —
   * o titulo, o contador e o botao de fechar somem junto. Depois de uma adicao
   * o tema redesenha a gaveta mais de uma vez, e a ultima passada devolve a
   * marca. Por isso quem desfaz tem que ser o mesmo observador que remonta os
   * modulos: relogio erra a ultima passada.
   */
  function destravar(d, carrinho) {
    if (!carrinho || !carrinho.item_count) return;
    // so escreve se a marca existe: remover classe inexistente TAMBEM registra
    // mutacao no Chrome, e escrever aqui redispara o observador de classe
    if (d.classList.contains('is-empty')) d.classList.remove('is-empty');
    var interno = d.querySelector('.drawer__inner');
    if (interno && interno.classList.contains('is-empty')) interno.classList.remove('is-empty');
  }

  function desenhar(d, carrinho) {
    try {
      destravar(d, carrinho);
      montarCabecalho(d, carrinho.item_count);
      ajustarItens(d);
      montarFaixa(d);
      montarOfertas(d, carrinho);
      montarRodape(d, carrinho);
    } catch (e) {
      if (window.console && console.warn) console.warn('[aura-cart]', e);
    }
  }

  function aplicar() {
    var d = gaveta();
    if (!d || trabalhando) return;
    var interno = d.querySelector('.drawer__inner');
    if (!interno) return;

    trabalhando = true;

    // O tema troca a gaveta inteira a cada mudanca de quantidade. Desenhar ja
    // com o carrinho que se conhece evita o intervalo em que os modulos somem e
    // voltam — era isso que fazia a gaveta piscar e "mudar toda".
    if (ultimoCarrinho) desenhar(d, ultimoCarrinho);
    trabalhando = false;

    pedirJson(cfg.rotas.cart)
      .then(function (carrinho) {
        var assinatura = assinaturaDe(carrinho);
        var mudou = assinatura !== ultimaAssinatura;
        ultimoCarrinho = carrinho;
        ultimaAssinatura = assinatura;

        // ja desenhado e nada mudou: nao mexe de novo
        if (!mudou && !faltaMontar(d)) return;

        trabalhando = true;
        desenhar(d, carrinho);
        trabalhando = false;
      })
      .catch(function () {});
  }

  function observar() {
    var d = gaveta();
    if (!d) return;

    // O tema troca o conteudo inteiro a cada mudanca de carrinho. O que dispara
    // uma nova passada e o sumico do marcador (conteudo novo) ou a gaveta abrir.
    // As escritas do proprio app nao contam, senao isto entraria em laco.
    var obs = new MutationObserver(function () {
      if (trabalhando) return;
      if (faltaMontar(d)) aplicar();
    });
    obs.observe(d, { childList: true, subtree: true });

    // abrir a gaveta refaz os modulos: o carrinho pode ter mudado por fora
    var estavaAberta = false;
    var obsClasse = new MutationObserver(function () {
      // so a TRANSICAO fechada -> aberta refaz os modulos; registro de classe
      // com a gaveta ja aberta (inclusive os que o proprio app gera ao
      // desenhar) nao pode redisparar, senao vira laco infinito
      var aberta = d.classList.contains('active');
      var abriu = aberta && !estavaAberta;
      estavaAberta = aberta;
      if (abriu && !trabalhando) aplicar();
    });
    obsClasse.observe(d, { attributes: true, attributeFilter: ['class'] });
  }

  function iniciar() {
    cfg = lerConfig();
    if (!cfg) return;

    // cor e largura vem da configuracao do bloco, nao do codigo
    var raizCss = document.documentElement;
    if (cfg.acento) raizCss.style.setProperty('--aura-cart-acento', cfg.acento);
    if (cfg.largura) raizCss.style.setProperty('--aura-cart-largura', cfg.largura + 'px');
    aplicar();
    observar();
    ['variant:add', 'cart:change', 'cart:refresh'].forEach(function (nome) {
      document.addEventListener(nome, aplicar);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
